export default __webpack_public_path__ + "static/sensible3-462f33539c01b5da3a0fe1daa4f96311.svg";